import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of, Subject } from "rxjs";
import { map, shareReplay, take, tap } from "rxjs/operators";
import { Chart, ChartResponseObject } from "@ui-components/models";
import { EmployeeLeaves } from "@ui-components/models";
import { EmployeeTransactions } from "@ui-components/models";
import { HoursByHr } from "@ui-components/models";
import { VacationsBalance } from "@ui-components/models";
// import { BaseResponse } from '@ui-components/shared/src/lib/shared-module';
import { DataSourcesService } from './data-sources.service';
@Injectable({
  providedIn: 'root'
})
export class ChartdataService {

  private chartDataSubject = new BehaviorSubject<Chart[]>([]);
  private VacationsBalanceDataSubject = new BehaviorSubject<VacationsBalance[]>([]);
  private EmployeeTransactionsDataSubject = new BehaviorSubject<EmployeeTransactions[]>([]);
  private EmployeeLeavesDataSubject = new BehaviorSubject<EmployeeLeaves[]>([]);
  private HoursByHrSubject = new BehaviorSubject<HoursByHr[]>([]);
  //Observable
  charts$: Observable<Chart[]> = this.chartDataSubject.asObservable();
  vacationsbalance$: Observable<VacationsBalance[]> = this.VacationsBalanceDataSubject.asObservable();
  employeetransactions$: Observable<EmployeeTransactions[]> = this.EmployeeTransactionsDataSubject.asObservable();
  employeeleaves$: Observable<EmployeeLeaves[]> = this.EmployeeLeavesDataSubject.asObservable();
  hoursbyhr$: Observable<HoursByHr[]> = this.HoursByHrSubject.asObservable();

  constructor(private http: HttpClient, private dataSourcesService: DataSourcesService) { }

  getChartData(apiId, datefrom, dateto, empId) {
    let arr = [];
    this.charts$.pipe(take(1)).subscribe((res) => (res));
    if (arr.length > 0) {
      return;
    }
    let data = {
      nCompanyID: "1",
      dtDateFrom: datefrom,
      dtDateTo: dateto,
      nEmpId: empId,
      inputType: ["nCompanyID", "dtDateFrom", "dtDateTo", "nEmpId"],
    };
    return this.http.post(`/ApiInvoker/Invoke/${apiId}`, data);
  }

  getVacationsBalanceData(apiId, empId) {
    let arr = [];
    this.vacationsbalance$.pipe(take(1)).subscribe((res) => (res));
    if (arr.length > 0) {
      return;
    }
    let data = {
      nCompanyID: "1",
      nEmployeeID: empId,
      inputType: ["nCompanyID", "nEmployeeID"],
    };

    return this.http.post(`/ApiInvoker/Invoke/${apiId}`, data);
  }

  getEmployeeLeavesData(apiId, datefrom, dateto, empId) {
    let arr = [];
    this.employeeleaves$.pipe(take(1)).subscribe((res) => (res));
    if (arr.length > 0) {
      return;
    }
    let data = {
      nCompanyId: "1",
      dtFromDate: datefrom,
      dtToDate: dateto,
      nLeaveType: "2",
      nempId: empId,
      inputType: ["nCompanyId", "dtFromDate", "dtToDate", "nLeaveType", "nempId"],
    };
    return this.http.post(`/ApiInvoker/Invoke/${apiId}`, data);
  }

  getEmployeeTransactionsData(apiId, datefrom, dateto, empId) {
    let arr = [];
    this.employeetransactions$.pipe(take(1)).subscribe((res) => (res));
    if (arr.length > 0) {
      return;
    }
    let data = {
      nCompanyID: "1",
      dpFrom: datefrom,
      dpToDate: dateto,
      nEmployeeID: empId,
      inputType: ["nCompanyID", "dpFrom", "dpToDate", "nEmployeeID"],
    };
    return this.http.post(`/ApiInvoker/Invoke/${apiId}`, data);
  }

  getHoursAddedByHrData(apiId, datefrom, dateto, empId) {
    let arr = [];
    this.hoursbyhr$.pipe(take(1)).subscribe((res) => (res));
    if (arr.length > 0) {
      return;
    }
    let data = {
      nCompanyID: "1",
      dExtraHours: "0",
      dtFromDate: datefrom,
      dtToDate: dateto,
      nEmployeeID: empId,
      inputType: ["nCompanyID", "dExtraHours", "dtFromDate", "dtToDate", "nEmployeeID"],
    };
    return this.dataSourcesService.invokeDataSource(apiId, data)
      .pipe(
        map((res) => res.content),
        tap((res: HoursByHr[]) => this.HoursByHrSubject.next(res)),
        shareReplay(1)
      );
  }
  getTimeSheetData(apiId, datefrom, dateto, empId) {
    let arr = [];
    this.charts$.pipe(take(1)).subscribe((res) => (res));
    if (arr.length > 0) {
      return;
    }
    let data = {
      nCompanyID: "1",
      dtDateFrom: datefrom,
      dtDateTo: dateto,
      nEmpId: empId,
      inputType: ["nCompanyID", "dtDateFrom", "dtDateTo", "nEmpId"],
    };
    return this.http.post(`/ApiInvoker/Invoke/${apiId}`, data);
  }
}
